<div class="lpx-sgu-app-layout">
  <!-- Top header spanning full width -->
  <header class="lpx-sgu-header bg-primary text-white d-flex justify-content-between align-items-center">
    <div class="lpx-sgu-header-left">
      <!-- Logo / brand -->
       <div class="lpx-logo-container">
        <lpx-brand-logo />
       </div>

    </div>

    <div class="lpx-sgu-header-right">
      <!-- Toolbar / user / settings area -->
      <lpx-toolbar-container></lpx-toolbar-container>
    </div>
  </header>

  <!-- Optional mobile navbar (small screens) -->
  <div class="lpx-sgu-mobile-navbar">
    <ng-container *abpIfReplaceableTemplateExists="mobileNavbarKey">
      <ng-container *abpReplaceableTemplate="{ componentKey: mobileNavbarKey }"></ng-container>
    </ng-container>
  </div>

  <!-- Main body: left menu + content under the header -->
  <div class="lpx-sgu-body">
    <div id="lpx-wrapper" [ngClass]="containerClass$ | async">
      <div class="lpx-sidebar-container">
        <div class="lpx-sidebar lpx-scroll-container">


          <lpx-navbar >
             <ng-template lpx-logo-panel>
              <!-- Empty template to hide the default logo -->
            </ng-template>

            <!-- Use the same routes component as the standard side menu layout -->
            <ng-template lpx-navbar-routes let-items let-groupItems="groupItems">
              <lpx-navbar-routes *abpReplaceableTemplate="{
                  componentKey: routesKey,
                  inputs: {
                    navbarItems: { value: items },
                    groupItems: { value: groupItems },
                  },
                }" [navbarItems]="items" [groupedItems]="groupItems">
              </lpx-navbar-routes>
            </ng-template>
          </lpx-navbar>
        </div>
      </div>

      <div class="lpx-content-container">
        <div class="lpx-content-wrapper">
          <div class="lpx-content">
            <!-- Breadcrumb above content -->
            <ng-container *abpIfReplaceableTemplateExists="breadcrumbKey">
              <div class="lpx-sgu-breadcrumb">
                <ng-container *abpReplaceableTemplate="{ componentKey: breadcrumbKey }">
                </ng-container>
              </div>
            </ng-container>

            <!-- Page alerts -->
            <abp-page-alert-container
              *abpReplaceableTemplate="{ componentKey: pageAlertContainerKey }"></abp-page-alert-container>

            <!-- Routed content -->
            <router-outlet></router-outlet>

            <!-- Optional footer at bottom of content -->
            <ng-container *abpIfReplaceableTemplateExists="footerKey">
              <footer class="lpx-sgu-footer">
                <ng-container *abpReplaceableTemplate="{ componentKey: footerKey }">
                </ng-container>
              </footer>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
